/**
 * Параметри Firebase для веб-застосунку.
 *
 * Це НЕ секрети: конфіг веб-застосунку Firebase є публічним за побудовою і
 * потрапляє в бандл будь-якого веб-клієнта. Захист даних забезпечують правила
 * доступу на боці Firebase, а не приховування цих значень.
 *
 * Це той самий веб-застосунок, що був у Flutter Web (`lib/firebase_options.dart`,
 * `web`): потік даних GA лишається тим самим, і історія до й після переходу на
 * TypeScript читається як одна.
 *
 * ⚠️ Раніше значення бралися зі змінних оточення збірки, але деплой їх ніколи
 * не передавав — і з 6 вересня 2026 аналітика на проді мовчки не працювала.
 * Тому конфіг лежить у коді: забути його підставити неможливо.
 */
export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

const webAppConfig: FirebaseConfig = {
  apiKey: 'AIzaSyA4biTWOETwNsnGd1ApzMRg2Nqq6NeXZ1c',
  authDomain: 'one2one-6ea2c.firebaseapp.com',
  projectId: 'one2one-6ea2c',
  storageBucket: 'one2one-6ea2c.firebasestorage.app',
  messagingSenderId: '794294201833',
  appId: '1:794294201833:web:47bb3ee6ffc75f2429af78',
  measurementId: 'G-H7H9HW9P45',
};

/**
 * Аналітика вмикається лише в продакшн-збірці: `npm run dev` і тести не мають
 * засмічувати бойовий потік подіями з локальної машини.
 */
export function firebaseConfig(): FirebaseConfig | null {
  return import.meta.env.PROD ? webAppConfig : null;
}
